/**
 * @param installationId
 * @param emcId from dto device-links emc.id (or parsed emc.deviceId)
 * @param evseId from dto sub device-links controlled.id (or parsed evse.deviceId)
 */
export const scanForEvseWs = (installationId: number, emcId: string, evseId: string, token: string): WebSocket => {
  return new WebSocket(
    `${process.env.REACT_APP_INSTALLATIONS_ENDPOINT}/installations/${installationId}/device-links/${emcId}/sub/${evseId}/scan/evse/ws?authorization=${token}`
  )
}
